import React, {useState} from "react";
import { Alert, Modal } from "react-bootstrap";
import { HHIEButton } from "../../../utility/HHIEButton";
import { HHIEError } from "../../../utility/HHIEError";

export const SendTemporaryResetEmailModal = (props) => {
    const [show, setShow] = useState(false);
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const [success, setSuccess] = useState(false);

    function handleError(msg) {
        setError(true);
        setErrorMsg(msg);
    }
    const resetPwd = async (pocUserId) => {
        let pocExists = await fetch('api/PocUser/user-exists-with-userid/' + pocUserId)
            .then(async (response) => {
                try {
                    return await response.json().then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message
                    });
                }
                catch (ex) {
                    handleError("pocExistInDatabase error: " + ex);
                    return console.log("pocExistInDatabase error: ", ex);
                }
            })
            .catch((ex) => {
                handleError("pocexist in database response error: " + ex);
                console.log("pocexist in database response error: ", ex);
            });
        if (!pocExists) {
            handleError("This POC has not registered, and is not in the system. Please contact the HHIE.")
            return;
        }
        const formData = new FormData();
        formData.append("pocUserId", pocUserId);
        formData.append("requestorSfId", props.user.sfid);

        const requestOptions = {
            method: 'POST',
            body: formData
        };

        const result = await fetch('api/user/resetPocPasswordFromDashboardAndSendEmail', requestOptions)
            .then(async (response) => {
                try {
                    return await response.json().then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message
                    });
                }
                catch (ex) {
                    handleError("reset error: " + ex);
                    return console.log("resetPwd-json-err", ex);
                }
            })
            .catch(ex => {
                handleError("reset error: " + ex);
                console.log("resetPwd-response-err", ex);
            });
        if (result) {
            setSuccess(true);
        } else {
            handleError("Something went wrong, this user may not exist. Please contact the HHIE.");
        }
    }
    const handleClose = () => {
        setShow(false);
        setError(false);
        setErrorMsg(null);
        setSuccess(false);
    }
    return (
    <>
        <HHIEButton 
            size="sm" 
            title="Reset Password" 
            onClick={() => {
                setShow(true);
            }} 
        />
        <Modal
            show={show}
            onHide={() => {
                handleClose()
            }}
            backdrop="static"
            centered
        >
            {!success &&
            <>
                <Modal.Title>
                    <Modal.Header>
                        Send a Temporary Password Reset Email to {props.poc.email}
                    </Modal.Header>
                </Modal.Title>
                <Modal.Body>
                    Sends a Password Reset email to the specified email address, and if this email is associated with an account in our database, they will be emailed with their new temporary password.
                    {error && 
                        <HHIEError 
                            message={errorMsg} 
                            onClick={()=> {
                                setError(false); 
                                setErrorMsg(null);
                            }}
                        />
                    }
                </Modal.Body>
            </>
            }
            {success && <Alert variant="success">Email has been sent successfully!</Alert>}
                <Modal.Footer>
                    {!success && <HHIEButton
                        title="Send Password Reset Email"
                        size="sm"
                        onClick={() => {
                            resetPwd(props.poc.email);
                        }} 
                    />}
                    <HHIEButton
                        title="Close"
                        size="sm"
                        variant="warning"
                        onClick={() => {handleClose()}}
                    />
                </Modal.Footer>
        </Modal>
    </>

    );
}